import { resolveUpsell } from "../lib/upsell";
import type { UpsellConfig, UpsellRecommendation, UpsellResult } from "../lib/upsell";

const DEFAULT_CONFIG: UpsellConfig = {
  provider: "shopify",
  complementaryTitle: "Complete the routine",
  limit: 2,
  shopify: { intent: "complementary" },
  rebuy: { apiKey: "", dataSourceId: "" },
  bundles: [],
};

function readConfig(): UpsellConfig {
  const el = document.getElementById("upsell-config");
  if (!el?.textContent) return DEFAULT_CONFIG;
  try {
    return { ...DEFAULT_CONFIG, ...JSON.parse(el.textContent) };
  } catch (error) {
    return DEFAULT_CONFIG;
  }
}

export default () => ({
  loading: false,
  error: null as string | null,
  result: { title: "", recommendations: [] } as UpsellResult,
  config: DEFAULT_CONFIG,

  get hasRecommendations(): boolean {
    return this.result.recommendations.length > 0;
  },

  init() {
    this.config = readConfig();
    this.refresh();
    // Re-resolve whenever the cart contents change (add / remove / upgrade).
    this.$watch("$store.cart.data", () => this.refresh());
  },

  async refresh() {
    const cart = this.$store.cart.data;
    if (!cart?.items?.length) {
      this.result = { title: "", recommendations: [] };
      return;
    }

    this.loading = true;
    this.error = null;
    try {
      this.result = await resolveUpsell(cart, this.config);
    } catch (error) {
      this.error = "Could not load recommendations";
      this.result = { title: "", recommendations: [] };
      throw error;
    } finally {
      this.loading = false;
    }
  },

  async apply(rec: UpsellRecommendation) {
    if (this.$store.cart.loading) return;

    if (rec.actionType === "upgrade") {
      await this.$store.cart.replaceLines(rec.removeKeys ?? [], [
        { id: rec.id, quantity: 1 },
      ]);
    } else {
      await this.$store.cart.addLines([{ id: rec.id, quantity: 1 }]);
    }
  },
});
